import { render, staticRenderFns } from "./EodbTemporaryDetails.vue?vue&type=template&id=2ddfed2c&scoped=true&"
import script from "./EodbTemporaryDetails.vue?vue&type=script&lang=js&"
export * from "./EodbTemporaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./EodbTemporaryDetails.vue?vue&type=style&index=0&id=2ddfed2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddfed2c",
  null
  
)

export default component.exports